export enum AccessType {
	Editor = "editor",
	Viewer = "viewer"
}
